import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "bordered", "striped", "noHover", "active", "size", "renderItem", "className", "children", "header", "footer", "dataSource"];
import React from 'react';
import { ListItem } from './Item';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './Item';
function InternalList(props, ref) {
  var {
      prefixCls = 'w-list',
      bordered = true,
      striped = false,
      noHover = false,
      active = false,
      size = 'default',
      renderItem,
      className,
      children,
      header,
      footer,
      dataSource = []
    } = props,
    resetProps = _objectWithoutPropertiesLoose(props, _excluded);
  var items;
  if (dataSource && dataSource.length > 0) {
    items = dataSource.map((item, index) => renderItem && renderItem(item, index));
  } else {
    items = children;
  }
  var childrenList = React.Children.map(items, (child, index) => /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
    key: index
  }));
  var classString = [prefixCls, className, striped ? prefixCls + "-striped" : null, noHover ? prefixCls + "-no-hover" : null, active ? prefixCls + "-active" : null, bordered ? prefixCls + "-bordered" : null, size && size !== 'default' ? prefixCls + "-size-" + size : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsxs("div", _extends({
    className: classString
  }, resetProps, {
    ref: ref,
    children: [header && /*#__PURE__*/_jsx("div", {
      className: prefixCls + "-header",
      children: header
    }), childrenList, footer && /*#__PURE__*/_jsx("div", {
      className: prefixCls + "-footer",
      children: footer
    })]
  }));
}
var List = /*#__PURE__*/React.forwardRef(InternalList);
List.Item = ListItem;
export default List;